import type { RecordRow } from '../../data/client';
import { formatDateTime } from '../../fields/format';
import { ActorLabel } from './ActorLabel';

/**
 * The system facts (INV-3), as ONE MUTED LINE at the end of the inspector pane
 * (`spec/screens/record.md` section 2 item 6).
 *
 * `createdBy` and `updatedBy` are filled by the write path, never by a caller, and
 * they are shown with their SOURCE: "updated two minutes ago" means something
 * different when an AI agent did it, and a record page that hides that is hiding the
 * one thing an operator checks first.
 *
 * P5 REPLACED THE "System" CARD WITH THIS LINE. A bordered card at the bottom of a
 * details pane is the frame around details Apple does not draw (section 7), and two
 * dates are not a section - they are a footnote.
 */
export interface RecordMetaCardProps {
  readonly record: RecordRow;
  readonly locale?: string | undefined;
}

export function RecordMetaLine({ record, locale }: RecordMetaCardProps) {
  return (
    <p className="record-meta-line">
      Created <time dateTime={record.createdAt}>{formatDateTime(record.createdAt, locale)}</time> by{' '}
      <ActorLabel actor={record.createdBy} />, last updated{' '}
      <time dateTime={record.updatedAt}>{formatDateTime(record.updatedAt, locale)}</time> by{' '}
      <ActorLabel actor={record.updatedBy} />.
    </p>
  );
}
